<div class="card card-default">
    <div class="card-body">
        <div class="card-header" style="padding-left:0px !important">Question List</div>
        <div class="form-group">
            <div class="form-group row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Section</th>
                                    <th>Question</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let question of questions">
                                    <td>{{getSectionName(question.sectionId)}}</td>
                                    <td>{{question.title}}</td>
                                    <td>
                                        <button class="btn btn-xs btn-info" type="button" (click)="edit(question)">Edit</button>&nbsp;
                                        <button class="btn btn-xs btn-warning" type="button" (click)="delete(question.id)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-10">
        <pagination [totalItems]="count" (pageChanged)="pageChanged($event)" [itemsPerPage]="10" [(ngModel)]="currentPage"></pagination>
    </div>
    <div class="col-md-2 text-right">
        <button class="btn btn-info" (click)="newQuestion()">New Question</button>
    </div>
</div>

<div>
    <accordion>
        <accordion-group panelClass="b0 mb-2" [isOpen]="isFormOpen">
            <form [formGroup]="questionFormGroup" class="form-validate form-horizontal" (submit)="submitForm(mainForm)" #mainForm="ngForm">
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Section</label>
                    <div class="col-md-8">
                        <select class="form-control" formControlName="sectionId">
                            <option [ngValue]="null">Please Select</option>
                            <option value="{{section.id}}" *ngFor="let section of sections">{{section.title}}</option>
                        </select>
                        <span class="text-danger" *ngIf="questionFormGroup.controls['sectionId'].hasError('required') && (questionFormGroup.controls['sectionId'].dirty || questionFormGroup.controls['sectionId'].touched||mainForm.submitted)">This field is required</span>
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-primary" (click)="openSectionModal($event)">Create Section</button>
                    </div>

                </div>

                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Title</label>
                    <div class="col-md-9">
                        <input class="form-control" type="text" formControlName="title" />
                        <span class="text-danger" *ngIf="questionFormGroup.controls['title'].hasError('required') && (questionFormGroup.controls['title'].dirty || questionFormGroup.controls['title'].touched||mainForm.submitted)">This field is required</span>
                    </div>

                </div>

                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Answer</label>
                    <div class="col-md-9">
                        <textarea class="form-control" type="text" formControlName="answer"></textarea>
                        <span class="text-danger" *ngIf="questionFormGroup.controls['answer'].hasError('required') && (questionFormGroup.controls['answer'].dirty || questionFormGroup.controls['answer'].touched)||mainForm.submitted">This field is required</span>
                    </div>

                </div>
                <div class="form-group row">
                    <div class="col-md-2"></div><div class="col-md-10">
                        <button type="submit" class="btn btn-secondary">Save</button>
                    </div>
                </div>
            </form>
        </accordion-group>
    </accordion>
</div>

<ngx-smart-modal #sectionModal identifier="sectionModal" customClass='msg-modal'>
    <app-section [sections]="sections" (sectionsChanged)='updateSections($event)'></app-section>
</ngx-smart-modal>
